





































import { Vue, Component, Prop } from 'vue-property-decorator';
import { shipCompany } from '@/api/shipment';
import { emptyRule, rangeLengthRule } from '@/utils/rules';
//806404690560875513 圆通
@Component({})
export default class LogisticsManageList extends Vue {
  /**物流公司 */
  shipItems: any[] = [...shipCompany];

  /**数据 */
  @Prop({
    default: () => {
      return [];
    }
  })
  value!: Array<any>;
 /**数据 */
  @Prop({
    default:50
  })
  lognumber!: Array<any>;

  mounted() {
  }

  /**快递单号rule */
  get shipNumberRules() {
    return []
    // return [rangeLengthRule(5, 25, '快递单号')];
  }

  /**物流公司rule */
  get shipCompanyRules() {
    return []
    // return [emptyRule('物流公司')];
  }

  /**物流单号输入事件 */
  onLogisticNumber(event: any, item: any) {
    if (event) {
      // 只能输入数字
      // let t = event.replace(/\D/g, '');
       //只能输入数字和英文
      let t = event.replace(/[\W]/g,'')
      this.$nextTick(() => {
        item.number = t;
      });
    }
  }

  /**新增 */
  handleAdd() {
    this.value.push({
      company: '',
      number: ''
    });
  }

  /**删除 */
  handleRemove(index: any) {
    this.value.splice(index, 1);
  }
}
